import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

export const getStoreHoursMessage = (store: any): string | null => {
  const today = dayjs().format('ddd').toLowerCase()
  const hours = store[`hours_${today}`]
  if (!hours) return null

  const [openTime, closeTime] = hours.split(':')
  const now = dayjs()
  const storeOpen = dayjs(openTime, 'HHmm')
  const storeClose = dayjs(closeTime, 'HHmm')

  const isOpen = now.isAfter(storeOpen) && now.isBefore(storeClose)

  const formatTime = (time: dayjs.Dayjs) => {
    return time.minute() === 0 ? time.format('h A') : time.format('h:mm A')
  }

  if (isOpen) {
    return `closes at ${formatTime(storeClose)}`
  } else {
    return `opens at ${formatTime(storeOpen)}`
  }
}
